export class LoadCategoriesList {
  static readonly type = '[Listings] Load categories list';
}
export class LoadCountriesList {
  static readonly type = '[Listings] Load countries list';
}
